import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/App/Layout'
import Navbar from '../components/App/Navbar'
import PageBanner from '../components/Common/PageBanner'
import Footer from '../components/App/Footer'
import ServiceDetailsContent from '../components/ServiceDetails/ServiceDetailsContent'
import RelatedServices from '../components/ServiceDetails/RelatedServices'
import SEO from '../components/App/SEO'

const ServiceDetails = ({ data }) => {
  const { node } = data.allContentfulServices.edges[0]

  return (
    <Layout>
      <SEO title={node.title} />
      <Navbar />
      <PageBanner
        pageTitle={node.title}
        homePageText="Home"
        homePageUrl="/"
        activePageText={node.title}
      />
      <ServiceDetailsContent service={node} />
      <RelatedServices slug={node.slug} />
      <Footer />
    </Layout>
  )
}

export default ServiceDetails

export const query = graphql`
  query serviceSingleQuery($slug: String!) {
    allContentfulServices(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          slug
          title
          content {
            content
          }
          featured {
            fluid(maxWidth: 750) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`
